import React from 'react';
import { Field, Textarea } from '@billda/design-system';
import { useFormContext, useWatch } from 'react-hook-form';
import { SiteImportFormData } from '../../../../schemas/siteImportSchema';

const NotesField: React.FC = () => {
  const { control, setValue } = useFormContext<SiteImportFormData>();
  const notes = useWatch({ control, name: 'notes' }) ?? '';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue('notes', event.target.value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  return (
    <Field label="Notes">
      <Textarea
        rows={3}
        value={notes}
        onChange={handleChange}
        data-testid="site-notes-input"
      />
    </Field>
  );
};

export default NotesField;
